<template>

    <Page class="text-lg !max-w-[80%]">

        <div>
            <h2 class="text-xl font-semibold">Next Steps</h2>
            <ul class="mt-1 list-decimal text-white/60">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    Log into the Carbucks LMS
                </li>
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    Read and review training materials
                </li>
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    Complete Tutorials and Training
                </li>
            </ul>
        </div>

    </Page>

</template>